export default __webpack_public_path__ + "static/media/brand_08.654cbac8.png";